import {setPersistedAtValue} from '../../../actions/financialEducation/persistedAt'

export const financialEducationPeristedAt = (store, next, action) => {
    const result = next(action);
    store.dispatch(setPersistedAtValue());
    return result;
}
